export enum PreBindFileTypeEnum{
  None = 0,
  FloridaSurplusLinesForm = 1,
  FloridaNFIPForm = 2
}
